export default ['en', 'de', 'fr', 'es', 'it'];
